<div
  class="min-h-screen bg-gradient-to-br from-[#2c5f8d] to-[#4A90E2] flex items-center justify-center p-4"
>
  <div class="w-full max-w-md">
    <!-- Logo -->
    <div class="text-center mb-8">
      <img
        src="https://zoomeduca.com.br/logo.svg"
        alt="Zoom Educa"
        class="w-32 mb-3 h-auto mx-auto brightness-0 invert drop-shadow-lg"
      />
      <h1 class="text-3xl font-bold text-white mb-2">Recuperar Senha</h1>
      <p class="text-white/90">
        Digite seu email para receber o código de recuperação
      </p>
    </div>

    <!-- Card -->
    <div class="bg-white rounded-lg shadow-xl p-8">
      <form (ngSubmit)="onSubmit()" #forgotForm="ngForm">
        <div class="space-y-6">
          <!-- Email -->
          <app-input
            label="Email"
            type="email"
            [(ngModel)]="email"
            name="email"
            #emailInput="ngModel"
            required
            email
            placeholder="seu@email.com"
            leftIcon="mail"
            [error]="
              submitted && emailInput.invalid
                ? emailInput.errors?.['required']
                  ? 'Email é obrigatório'
                  : 'Email inválido'
                : ''
            "
          ></app-input>

          <!-- Submit Button -->
          <button
            app-button
            type="submit"
            className="bg-[#4A90E2] hover:bg-[#2c5f8d] text-white"
            [loading]="isLoading"
            loadingText="Enviando..."
          >
            Enviar Código
          </button>

          <!-- Back to Login -->
          <button
            app-button
            variant="ghost"
            routerLink="/login"
            className="text-sm text-gray-600 hover:text-[#4A90E2] font-medium"
          >
            Voltar para o login
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
